<template>
    <div id="service">
        <div class="head-tool" v-if="show != 0">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">服务条款</span>
            <span class="tr"></span>
        </div>
        <div class="info">
            <h3>娱悦读账号服务条款</h3>
            <h5>一.总则</h5>
            <p>1.1 用户在进行注册登录程序过程中点击“同意”按钮即表示用户与娱悦读客户端所在公司达成协议，完全接受本协议项下的全部条款。</p>
            <p>1.2 用户注册成功后，娱悦读将给予每个用户一个用户帐号和密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。</p>
            <p>1.3 本服务条款内容包括协议正文及手机阅读平台上发布的声明和规则。包括但不限于版权声明、《隐私政策》、使用说明。所有声明和规则与协议正文具有同等法律效力。</p>
            <p>1.4 在使用娱悦读提供的各项服务之前，应仔细阅读本服务协议。如您不同意本服务协议，您可以主动取消娱悦读提供的服务；您一旦使用娱悦读服务，即视为您已了解并完全同意本服务协议各项内容，包括娱悦读对服务协议随时所做的任何修改，并成为娱悦读用户。</p>

            <h5>二.服务内容</h5>
            <p>2.1 娱悦读服务的具体内容由娱悦读根据实际情况提供。</p>
            <p>2.2 除非本协议另有其它明示规定，娱悦读所推出的新功能、新服务，均无条件的适用于本服务条款。</p>
            <p>2.3 除非本协议另有其它明示规定，否则娱悦读对服务不承担任何责任，即用户对服务的使用承担风险。娱悦读不保证服务一定会满足用户的使用要求，也不保证服务不会中断，对服务的及时性、安全性、准确性也不作担保。

            </p>
            <p>2.4 娱悦读保留在日后对全部或部分服务项目收取费用的权利。

            </p>
            <p>2.5 为了更好的帮助用户享受服务，部分服务需要用户注册登录才能使用，如：充值、购买收费书籍、社区发表内容等。

            </p>
            <p>2.6 由于用户经由本服务张贴、上传或传送内容、与本服务连线、违反本服务条款或侵害其他人的任何权利导致任何第三方提出权利主张或使娱悦读遭受任何形式的罚款或处罚，用户同意以适当方式充分消除对娱悦读的不利影响，赔偿娱悦读及其分公司、关联公司、代理人或其他合作伙伴及员工的损失，并使其免受损害。

            </p>

            <h5>三.使用规则</h5>
            <p>用户在使用娱悦读服务时必须遵守中华人民共和国相关法律法规的规定，用户应同意将不会利用本服务进行任何违法或不正当的活动，包括但不限于下列：

            </p>
            <p class="p1">1)从中国境内向外传输技术性资料时必须符合中国有关法规。</p>
            <p class="p1">2)使用网站服务不作非法用途。</p>
            <p class="p1"> 3)不干扰或混乱网络服务。

            </p>
            <p class="p1">4)不在社区BBS或评论区发表任何与政治相关的信息。</p>
            <p class="p1">5)遵守所有使用网络服务的网络协议、规定、程序和惯例。

            </p>
            <p class="p1">6)不得利用本站危害国家安全、泄露国家秘密，不得侵犯国家社会集体的和公民的合法权益。</p>
            <p class="p1">7)不得利用本站制作、复制和传播下列信息：</p>
            <p class="p2">1、煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
            <p class="p2">2、煽动颠覆国家政权，推翻社会主义制度的；</p>
            <p class="p2">3、煽动分裂国家、破坏国家统一的；</p>
            <p class="p2">4、煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p class="p2">5、捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
            <p class="p2">6、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
            <p class="p2">7、公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
            <p class="p2">8、损害国家机关信誉的；</p>
            <p class="p2">9、其他违反宪法和法律行政法规的；</p>
            <p class="p2">10、进行商业广告行为的。</p>
            <p>用户不能传输任何教唆他人构成犯罪行为的资料；不能传输长国内不利条件和涉及国家安全的资料；不能传输任何不符合当地法规、国家法律和国际法 律的资料。未经许可而非法进入其它电脑系统是禁止的。若用户的行为不符合以上的条款，娱悦读将有权取消用户服务帐号。</p>
            <h5>四. 隐私策略</h5>
            <p>保护用户(特别是未成年人)的隐私是娱悦读的一项基本政策，娱悦读将对用户所提供的资料进行严格的管理及保护，并使用相应的技术，防止用户的个人资料丢失、被盗用或遭篡改，保证不单方面对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在娱悦读的非公开内容，娱悦读将在出现下述情形时披露您有关个人身份的信息：</p>
            <p>1. 您授权或同意娱悦读披露的；</p>
            <p>2. 在紧急情况下，为了保护娱悦读及其用户的合法权益或公共安全及利益；

            </p>
            <p>3. 根据法律规定或有权部门的要求提供您的个人信息；</p>
            <p>详见 <router-link :to="{path:'/privacy'}">《隐私政策》</router-link>。</p>
            <h5>五. 版权声明</h5>
            <p>娱悦读定义的内容包括：文字、软件、声音、相片、录象、图表；电子邮件的全部内容；娱悦读为用户提供的商业信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。所以，用户只能在娱悦读客户端上才能使用这些内容，而不能擅自复制、篡改这些内容、或创造与内容有关的派生产品

            </p>
            <h5>六. 免责条款

            </h5>
            <p>6.1 用户明确同意娱悦读服务的使用由用户个人承担风险。</p>
            <p>6.2 娱悦读不作任何类型的担保，不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性，安全性，出错发生都不作担保。用户理解并接受：任何通过娱悦读服务取得的信息资料的可靠性取决于用户自己，用户自己承担所有风险和责任。

            </p>
            <p>6.3 任何通过使用娱悦读而连接到的第三方网页均系他人制作或提供，您可能从第三方网页上获得其他服务，娱悦读对其合法性概不负责，亦不承担任何法律责任。</p>
            <p>6.4 第三方搜索引擎的搜索结果满足您的需求，不保证搜索服务不中断，不保证搜索结果完整性、正确性、及时性、合法性。因网络状况、通讯线路、第三方网站等任何原因而导致您不能正常使用娱悦读，娱悦读不承担任何法律责任。</p>
            <p>6.5 娱悦读鼓励广大小说爱好者通过娱悦读发现优秀网络小说及其提供商，并建议阅读正版图书。任何单位或个人认为通过阅读搜索链接到第三方网页内容可能涉嫌侵犯其信息网络传播权，应该及时向娱悦读提出书面权利通知，并提供身份证、权属证明及详细侵权情况证明。娱悦读在收到上述法律文件后将依法尽快断开链接内容。</p>
            <h5>七. 其他</h5>
            <p>如用户对本条款内容有任何疑问，可通过电子邮件kefuzhuanyong@xinghuozw.com联系我们。</p>





        </div>
    </div>
</template>

<script>
    export default {
        name: "Service",
        data(){
            return {
                show : this.$route.query.a || 1
            }
        },

    }
</script>

<style lang="less">
#service{
    .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
        span{flex:1;font-size: 30px;color:#333;
            i{font-size: 30px;}
        }
    }
    .info{
        padding:20px;
        h3{text-align: center;font-size: 40px;}
        h5{font-size: 30px;}
        p{font-size: 24px;color:#333;padding: 20px 0;}
        .p1{padding-left: 20px;}
        .p2{padding-left: 40px;}
    }
}
</style>
